import Address from "../apis/address";
import router from "@/router";

const state = {
  addressList: [],
  deleteAddress: [],
  addAddress: {},
  primaryAddress: {},
};
const actions = {
  getAddress({ commit }, data) {
    return Address.addressList(data).then((response) => {
      if (response.status == 200 || response.status == true) {
        return response.data;
        // commit("getAddress", response.data);
      }
      return response.data;
    }).catch((error) => {
      throw error
    })
  },


  // async getAddress({ commit }, data) {
  //   try {
  //     const response = await Address.addressList(data);
  //     if (response && response.status === true) {
  //       commit("getAddress", response.data);
  //     } else {
  //       // Optional: handle known API errors gracefully
  //       commit("getAddress", response.data);
  //       console.warn("API responded with status false", response.message);
  //     }
  //     return response.data;
  //   } catch (error) {
  //     // Handle unexpected errors such as network issues or 404
  //     console.error("API call failed:", error);
  //     // Optional: commit empty data or set error state
  //     commit("getAddress", []);
  //     return error.response
  //     // Re-throw or return custom error if needed
  //     // return { error: true, message: error.message || "Something went wrong" };
  //   }
  // },


  removeAddress({ commit }, data) {
    return Address.deleteAddress(data).then((response) => {
      if (response.status == true) {
        // commit("removeAddress", response.data.Result)
        return response.data;
      }
      return response.data;
    }).catch((error) => {
      throw error;
    });
  },

  newAddress({ commit }, data) {
    return Address.addAddress(data).then((response) => {
      if (response.status == true) {
        localStorage.setItem("latitude", response.data.latitude);
        localStorage.setItem("longitude", response.data.longitude);
        commit("newAddress", response.data);
      }
      return response.data;
    });
  },

  updateNewAddress({ commit }, { data, address_id }) {
    return Address.updateAddress(data, address_id).then((response) => {
      if (response.status == true) {
        //commit("updateNewAddress", response.data.Result)
        return response.data;
      }
      return response.data;
    });
  },

  getPrimaryAddress({ commit }, data) {
    return Address.primaryAddress(data).then((response) => {
      if (response.status == 200) {
        commit("primaryAddressMutation", response.data.data);
        return response.data;
      }
      return response.data;
    }).catch((error) => {
      router.push({ name: "add-address" }).catch(() => { });
    })
  },

  setPrimaryAddress({ commit }, data) {
    return Address.setPrimaryAddress(data).then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return response.data;
    })
  },

  checkDeliveryZone({ commit }, { data, latitude, longitude }) {
    return Address.checkDeliveryZone(data, latitude, longitude).then((response) => {
      if (response.status == true) {
        localStorage.setItem('is_delivery_zone_available', response.data.is_delivery_zone_active)
        return response.data
      }
      return response.data
    })
  },

  getUserNearAddressData({ commit }, data) {
    return Address.getUserAddress(data).then((response) => {
      if (response.data.code == true) {
        commit("primaryAddressMutation", response.data.Result);
      }
      return response.data;
    });
  },
};
const mutations = {
  getAddress(state, addressList) {
    state.addressList = addressList;
  },
  newAddress(state, addAddress) {
    state.addressList.push(addAddress);
    // state.addAddress = addAddress
  },
  primaryAddressMutation(state, primaryAddress) {
    state.primaryAddress = primaryAddress;
    if (Object.keys(primaryAddress).length > 0) {
      state.primaryAddress["deliveryAddress"] =
        primaryAddress.flat_no +
        " " +
        primaryAddress.house_name +
        " " +
        primaryAddress.address;
    }
  },
};
const getters = {
  addressList: (state) => state.addressList,
  deleteAddress: (state) => state.deleteAddress,
  addAddress: (state) => state.addAddress,
  primaryAddress: (state) => state.primaryAddress,
};

export const address = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
